var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasMediaSrc)?_c('img',{staticClass:"imageMedia",attrs:{"src":_vm.revMediaSrc,"width":"100%","height":"100%"}}):(_vm.showEmptyState)?_c('ImageEmptyState',{staticClass:"h-100",attrs:{"icon":"mdi-image-outline"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }